// extracted by mini-css-extract-plugin
export default {"genericCard":"Np-z","inline":"Op-z","mastercard":"Pp-z","discover":"Qp-z","visa":"Rp-z","amex":"Sp-z","active":"Tp-z"};